module.exports = "/_next/static/images/BuildHighPerformance-3@2x-55a14bb4405239816448b633739ae558.png";